import React, {useEffect} from 'react';
import {onActionBroadcast} from "@/broadcasts/actionBroadcast";
import {SetState} from "@/redux/reduxhelper";
import {IS_AUTH} from "@/redux/action/type.action";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router";

const ActionProvider = ({children}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        onActionBroadcast({
            onLogin: (token) => {
                localStorage.setItem("access_token", token);
                // console.log("received token from other tabs", token)
                dispatch(SetState(IS_AUTH, true));
                let pathName = window.location.pathname;
                if (pathName === '/') navigate(pathName);
                // window.location.reload();
            },
            onLogout: () => {
                localStorage.removeItem("access_token");
                dispatch(SetState(IS_AUTH, false))
                navigate("/");
            },
        });
    }, []);

    return (
        <>
            {children}
        </>
    );
};

export default ActionProvider;